import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import '../../Restrictions/RestrictionNeedToKnow/RestrictionNeedToKnow.css';

const WhyChooseMIICE = () => {
  const needToKnowData = [
    {
      title: "Quarantine Rules",
      description: "Different countries have differing quarantine requirements. Some destinations require a 7-day quarantine on arrival, while others don't require vaccinated travelers."
    },
    {
      title: "Entry Requirements",
      description: "Entry protocols differ widely; some countries require negative COVID-19 test results taken within 72 hours of departure, and certain destinations might ask for travel insurance."
    },
    {
      title: "Health Protocols",
      description: "Mandatory mask-wearing in public spaces, social distancing guidelines, and specific vaccination requirements come under health measures in a different country."
    },
    {
      title: "Flight & Transit Policies",
      description: "Airlines and transit hubs have their own set of regulations. Some enforce strict mask policies or have rules like mandatory testing during layovers."
    },
    {
      title: "Health Protocols",
      description: "Mandatory mask-wearing in public spaces, social distancing guidelines, and specific vaccination requirements come under health measures in a different country."
    },
    {
      title: "Flight & Transit Policies",
      description: "Airlines and transit hubs have their own set of regulations. Some enforce strict mask policies or have rules like mandatory testing during layovers."
    }
  ];

  return (
    <>
        <div className="need-to-know"> 
            <h1 className='headings text-center'><span>Why</span>Choose MICE?</h1>
        <div className="container">
            <div className="restrictionNeedRow mt-md-5 gap-md-3">
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[0].title}</h2>
                        <p>{needToKnowData[0].description}</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[1].title}</h2>
                        <p>{needToKnowData[1].description}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="restrictionNeedRow my-md-4 gap-md-3">
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[2].title}</h2>
                        <p>{needToKnowData[2].description}</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[3].title === "Flight & Transit Policies" ? (
                          <>Flight <span className='text-dark' style={{fontWeight: 'bold'}}>&</span> Transit Policies</>
                        ) : (
                          needToKnowData[3].title
                        )}</h2>
                        <p>{needToKnowData[3].description}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="restrictionNeedRow my-md-4 gap-md-3">
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[4].title}</h2>
                        <p>{needToKnowData[4].description}</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="need-frame1">
                        <div className="frame1-txt d-flex flex-column justify-content-start align-items-start">
                        <h2 className='headings'>{needToKnowData[5].title === "Flight & Transit Policies" ? (
                          <>Flight <span className='text-dark' style={{fontWeight: 'bold'}}>&</span> Transit Policies</>
                        ) : (
                          needToKnowData[5].title
                        )}</h2>
                        <p>{needToKnowData[5].description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </>
  )
}

export default WhyChooseMIICE